export default __webpack_public_path__ + "static/media/la_rioja.1bd2c4b3.jpg";